module.exports = __webpack_public_path__ + "static/media/details.add91df9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/details.svg
// module id = 6
// module chunks = 1